/*!
 * textData.js — text(data:...): lines of digits, as data scrolls past
 * © 2026 Rob Canning — GPLv3
 *
 *     text(data:bin)                 0110 1001 ... -- a new line every quarter beat
 *     text(data:hex, length:48)      3F A0 07 ... -- 48 characters a line
 *     text(data:dec, trig:beat.div(4))   digits, a new line each sixteenth
 *     text(data:float, ticker:1, speed:400)   0.482913 1.093844 ... crawling past
 *
 * Kinds: bin (groups of 8 bits), hex (byte pairs), dec (groups of 4 digits),
 * float (six decimals). Pure: text.js makes them its cycle: (or its ticker:).
 */

const DATA_KINDS = ["bin", "hex", "dec", "float"];

/** One line of `kind`, `len` characters long (cut at a group's end where it can be). */
export function dataLine(kind, len = 32, rnd = Math.random) {
  const group = {
    bin: () => Array.from({ length: 8 }, () => (rnd() < 0.5 ? "0" : "1")).join(""),
    hex: () => Math.floor(rnd() * 256).toString(16).toUpperCase().padStart(2, "0"),
    dec: () => String(Math.floor(rnd() * 10000)).padStart(4, "0"),
    float: () => (rnd() * (rnd() < 0.2 ? 10 : 1)).toFixed(6),
  }[DATA_KINDS.includes(kind) ? kind : "hex"];
  let out = "";
  while (out.length < len) out += (out ? " " : "") + group();
  return out.slice(0, len).trimEnd();
}
